export default __webpack_public_path__ + "static/media/picture.65b73b17.svg";